module.exports = "<p>\n  base works!\n</p>\n";


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/base/base.component.html
// module id = 163
// module chunks = 0